export default __webpack_public_path__ + "73dbd424fe8a6b3e3f925a44789947ed.svg";